import Cookies from 'js-cookie'

const User = 'vue_admin_template_user'

export function getUserID() {
  return Cookies.get(User)
}

export function setUserID(UserID) {
  return Cookies.set(User, UserID)
}

export function removeUserID() {
  return Cookies.remove(User)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js